'use client'

import { useRouter } from 'next/navigation'
import { createClient } from '../../lib/supabase/client'
import IconCircle from '../../components/IconCircle'
import { forgetCard } from '../../components/UserChip'
import { forgetRoomCaches } from '../../components/ours/room'
import { forgetAllResumable } from '../../lib/os/resume'

export default function SignOutButton() {
  const router = useRouter()

  const signOut = async () => {
    const supabase = createClient()
    await supabase.auth.signOut()
    // the top-right chip caches who is looking for the tab's life — a soft
    // navigation out must not leave your face on the front door.
    forgetCard()
    // …and so does the room's page: what it read, the day's offer and its tab notes are the last
    // person's, and the next person to sign in on this tab must not be answered from them.
    forgetRoomCaches()
    // …and every place kept in this browser (an unsent line, a name being typed, where a page was read)
    forgetAllResumable()
    router.push('/')
    router.refresh()
  }

  return (
    <IconCircle onClick={signOut} title="sign out" aria-label="sign out">
      {/* door + arrow out */}
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <path d="M16 17l5-5-5-5" />
        <path d="M21 12H9" />
      </svg>
    </IconCircle>
  )
}
